<template>

<div 
:id="tileClass"
class='tile-div'
:class="{'is-fullvh': isFullVh, 'is-halfvh': !isFullVh}"
>

	<div class='container'>
		<div class='section'>
			<div class='columns is-centered is-vcentered'>

				<div class='column tile-icon-div' v-if="tileIcon">
					<img class='tile-icon' :src="getImgUrl(tileIcon)" :alt="imgAlt">
				</div>
			
				<div class='column is-8'>
					<div v-if="tileIcon" class='tile-title-div'>
						<h1 class='tile-title has-text-left'>
							<slot name='title' />
						</h1>
					</div>
					<p class='tile-text has-text-left'> 
						<slot name='text' />
					</p>
				</div>
			</div>
		</div>
	</div>
</div>

</template>


<script>
	export default {
		props: ['tileClass', 'isFullVh', 'tileIcon', 'imgAlt'],
		methods: {
			getImgUrl(img) {
				var images = require.context('../assets/', false);
				return images('./' + img);
			}
		}
	}
</script>


